/*
 * CampaignUpdate container
 */

import React, { PropTypes as T } from 'react';
import { Field, reduxForm } from 'redux-form/immutable';

import { authService } from '../../utils/auth-service';
import AxiosService from '../../utils/axios-service';
import TextInput from '../../components/form-input-text';

// TODO Needs completing once it has been designed out
class CampaignNew extends React.Component {
  static contextTypes = {
    router: T.object,
  };

  componentDidMount() {
    const context = this;

    const routeParam = this.props.routeParams ? this.props.routeParams.id : '';

    const axiosService = new AxiosService(process.env.REACT_APP_API_BASE_URL, process.env.REACT_APP_API_TIMEOUT, { Authorization: `Bearer ${authService.getToken()}` });
    context.setState({ axiosService });

    axiosService
      .get(`campaigns/${routeParam}`, {})
      .then(response => {
        // TODO Update this when campaign isn't an array
        context.setState({
          campaign: response.data,
        });
        context.handleInitialise(response.data);
      })
      .catch(() => {
        // TODO Handle errors
        context.setState({
          campaign: null,
        });
      });
  }

  handleInitialise(campaign) {
    const { name, description, client, budget } = campaign;

    const initData = {
      campaignName: name,
      campaignDescription: description,
      campaignClient: client,
      campaignBudget: budget,
    };

    this.props.initialize(initData);
  }

  updateCampaign(formData) {
    // TODO The members, companyID and owners need to be inserted
    const companyId = '57ebe2dbb0be59ed84c63222';
    const owners = ['57ebe2dbb0be59ed84c63333'];
    const members = ['57ebe2dbb0be59ed84c63444'];

    const insertParams = {
      name: formData.campaignName,
      description: formData.campaignDescription,
      client: formData.campaignClient,
      budget: formData.campaignBudget,
      companyId,
      owners,
      members,
      createdDate: this.state.campaign.createdDate,
      liveDate: this.state.campaign.liveDate,
    };

    this.state.axiosService
      .put(`v1/campaigns/${this.state.campaign.id}`, insertParams)
      .then(() => {
        this.context.router.push(`/campaign/${this.state.campaign.id}`);
      })
      .catch(() => {
        // TODO Handle errors
      });
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <div className="body_container">

        <h1 className="margin20"> Update Campaign </h1>

        <div className="campaign_members_form_container">
          <form onSubmit={handleSubmit(this.updateCampaign.bind(this))}>
            <Field
              name="campaignName"
              type="text"
              component={TextInput}
              label="Campaign name"
            />
            <Field
              name="campaignDescription"
              type="text"
              component={TextInput}
              label="Description"
            />
            <Field
              name="campaignClient"
              type="text"
              component={TextInput}
              label="Client"
            />
            <Field
              name="campaignBudget"
              type="number"
              component={TextInput}
              label="Budget"
            />
            <div>
              <button
                bsStyle="primary"
                block
                bsClass="btn btn-block large_primary_button blue_button margintop20"
                type="submit"
              >
                update campaign
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

CampaignNew.propTypes = {
  routeParams: React.PropTypes.object,
};

function validate(values) {
  const errors = {};

  if (!values.campaignName) {
    errors.campaignName = 'Enter a campaign name.';
  }
  if (!values.campaignDescription) {
    errors.campaignDescription = 'Enter a campaign description.';
  }
  if (!values.campaignClient) {
    errors.campaignClient = 'Enter a clientID.';
  }
  if (!values.campaignBudget) {
    errors.campaignBudget = 'Enter a campaign budget.';
  }

  // TODO Do the rest of the validation
  return errors;
}

export default reduxForm({
  form: 'UpdateCampaignForm',
  validate,
})(CampaignNew);



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-update/index.js
 **/